export default "__VITE_ASSET__C0QmOM_W__"